module.exports = __webpack_public_path__ + "static/media/lily-carter-icon.555f7f8e.jpg";